import { getAuthorization } from 'controllers/controller';
import { getJobByIdService } from 'services';

export const getJobTitle = async (id) => {
  const authorization = getAuthorization();
  const { status, data } = await getJobByIdService(authorization, id);

  if (status !== 200) {
    console.error('Error', status);
    return false;
  }
  return data.response.jobRole;
};
